import React from 'react';
import DOMPurify from 'dompurify';
import { rewriteMoodleHtmlImages } from '../../../../../../support/moodleHelpers';
import { MoodleInstanceKey } from '../../../../../../support/slices/moodleSlice';

interface Props {
  pageObj: any;
  fallbackTitle?: string;
  instance: MoodleInstanceKey;
}

export default function MoodlePageRenderer({ pageObj, fallbackTitle, instance }: Props) {
  if (!pageObj) {
    return <div style={{ padding: '1.5rem' }}>No page content found.</div>;
  }

  const title = pageObj.name || fallbackTitle || 'Page';
  const html = rewriteMoodleHtmlImages(pageObj.content || '', instance);

  return (
    <div style={{ padding: '1.5rem' }}>
      <h2 style={{ marginTop: 0 }}>{title}</h2>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />
    </div>
  );
}